var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cards',{staticClass:"testimonial-cards"},_vm._l((_vm.testimonials),function(testimonial){return _c('TestimonialCard',{key:testimonial.Id,attrs:{"testimonial":testimonial}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }